import type { T } from "../../i18n";
import { Icon } from "../../components/Icon";

// Small pieces shared by the settings screens.

const FMT = new Intl.NumberFormat("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
/** Amounts in Western digits with two decimals, as the prototype shows them in both languages. */
export const money = (n: number) => <span className="num">{FMT.format(n)}</span>;

/** Menu entries the user's keys do not allow: shown, but locked with a "No permission" tag (prototype pattern). */
export const lockTag = (t: T) => ({ disabled: true, tag: t("noPermission") });

export function LockedButton({ label, title }: { label: string; title: string }) {
  return <button className="btn btn-primary acc-locked" disabled aria-disabled="true" title={title}><Icon name="plus" />{label}<span className="acc-lock"><Icon name="lock" /></span></button>;
}
